export default __webpack_public_path__ + "static/media/story-2l.25f4e7ff.png";